export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70fd98d31691f0c64a09ff6bf260165ca405f5fcc1&name=pushAdClickData!'